import React, {FC, Fragment, useState} from "react";
import CommonLayout from "../CommonLayout";
import {Tab} from "@headlessui/react";
import VisaPage7Item from "./VisaPage7Item";
import {useAppSelector} from '../../../utils/customHooks';

export interface PageAddListing7Props {}

const VisaPage7: FC<PageAddListing7Props> = () => {
  const {numberOfApplicants, applicantsData, uid} = useAppSelector(state => state.visa_page)
  let names = [...new Array(+numberOfApplicants)].map((el,index) => {
    return applicantsData[index]?.fullName ? applicantsData[index]?.fullName : `Заявитель ${index + 1}`
  })
  const prefix = uid?.split('-')[0]
  const isPH = prefix === 'PH' || prefix === 'VH';

  const [selectedIndex, setSelectedIndex] = useState(0)
  const [errorField, setErrorField] = useState<string | null>(null)

  const setSelectedAndErrorField = (index: number, fieldName:string) => {
    setSelectedIndex(index)
    setErrorField(fieldName)
  }

  const handleTabChange = (index: number) => {
    setSelectedIndex(index)
    setErrorField(null)
  }

  return (
    <CommonLayout
      index="05"
    >
      <>
        <div>
          <div className='mb-4'>
            <h2 className="text-2xl font-semibold">Добавьте фото документов </h2>
            <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Добавьте фото Ваших документов в формате PNG,PDF,JPG или BMP.
          </span>

          </div>
          <Tab.Group selectedIndex={selectedIndex} onChange={handleTabChange}>
            <Tab.List className="flex space-x-4 overflow-x-auto">
              {names.map((item) => (
                <Tab key={item} as={Fragment}>
                  {({selected}) => (
                    <button
                      className={`flex justify-center self-center px-4 py-2 text-sm rounded-full border focus:outline-none cursor-pointer transition-all ${
                        selected
                          ? "border-primary-600 bg-primary-50 text-primary-700"
                          : "border-neutral-300 dark:border-neutral-700"
                      } `}
                    >
                      {item}
                    </button>
                  )}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels>
              <Tab.Panels>
                {[...new Array(+numberOfApplicants)].map((el,index) => {
                  return (
                      <Tab.Panel className="" key={index}>
                        <VisaPage7Item index={index} isPH={isPH} setSelectedAndErrorField={setSelectedAndErrorField} errorField={errorField}/>
                      </Tab.Panel>
                  )
                })}
              </Tab.Panels>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </>
    </CommonLayout>
  );
};

export default VisaPage7;
